<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-preface element-without-heading" id="preface">
<div class="text" id="preface-text">
<p class="first first-in-chapter first-full-width">Want to be the first to have a chance to read the new books? Sign up for my <a class="content-external-link" href="http://cjlyons.net/signup" target="_blank">Thrillers with Heart newsletter HERE</a>—and you’ll also get a free copy of the first Lucy adventure, SNAKE SKIN!</p>
<div class="inline-image inline-image-kind-photograph inline-image-size-full inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end">
<div class="inline-image-container">
<a class="link-contains-image" href="http://cjlyons.net/signup" target="_blank">
<img alt="email signup" src="images/newmailsignupvellum.jpg"/>
</a>
</div>
</div>
<p class="subsq"><i>(Already read SNAKE SKIN? Feel free to share this offer with your thriller-loving friends!)</i></p>
<p class="subsq">Be sure to open the Thrillers with Heart emails; they’ll arrive every few weeks with info on contests, new books, and exclusive offers for my readers!</p>
<div class="inline-image inline-image-kind-freestanding inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin">
<div class="inline-image-container">
<a class="link-contains-image" href="http://cjlyons.net/signup" target="_blank">
<img alt="Thanks for reading! CJ" src="images/image-300thanks-448.jpg"/>
</a>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface.vue?4c4493dc